export default __webpack_public_path__ + "static/media/devX_daily.c535fd01.svg";